import axios from "axios";
import type { ResponseType } from "axios";

import { errorToast } from "shared/toast-service";

export class ApiHandler {
  // TODO: Issue MRP-2775
  // eslint-disable-next-line class-methods-use-this
  async request({
    url,
    headers = {},
    responseType = "json",
    body,
    method,
    params = {},
    skipToken = false,
    skipToast = true,
    retailerId: otherRetailerId,
    noHeader = false
  }: {
    url: string;
    headers?: { [key: string]: string };
    responseType?: ResponseType;
    body?: Record<string, unknown> | unknown[];
    method: "POST" | "PUT" | "PATCH" | "GET" | "DELETE";
    params?: { [key: string]: string };
    skipToken?: boolean;
    skipToast?: boolean;
    retailerId?: string;
    noHeader?: boolean;
  }) {
    // TODO: Issue MRP-2775
    // eslint-disable-next-line unicorn/no-null
    const token = skipToken ? null : localStorage.getItem("accessToken");
    const retailerId = sessionStorage.getItem("retailerId") || otherRetailerId;

    const adminHeaders =
      !noHeader && retailerId
        ? {
            "retailer-id": retailerId
          }
        : {};

    const tokenHeader = token ? { authorization: `Bearer ${token}` } : {};

    const isFormData = typeof FormData !== "undefined" && body instanceof FormData;

    const defaultHeaders = {
      ...adminHeaders,
      ...tokenHeader,
      ...(isFormData ? {} : { "Content-Type": "application/json" })
    };

    const requestHeaders = {
      ...defaultHeaders,
      ...headers
    };

    try {
      const response = await axios({
        url,
        headers: requestHeaders,
        data: isFormData ? body : JSON.stringify(body),
        params,
        method,
        responseType
      });

      if (response.status < 400) {
        return Promise.resolve(response.data);
      }

      // A whitelist-based middleware can be instated here for handling
      //   non-generic 4xx errors later on, based on route & response.
      // This is TBD, as making toasts based on speciffic scenarios might be
      //   cleaner if done as thunk side effects.

      if (!skipToast) {
        if (response.status === 403) {
          errorToast({
            title: "An error occurred",
            description: "Your requested resource is not available.",
            duration: 0
          });
        }

        if (response.status === 500) {
          errorToast({
            title: "Server Error",
            description: "We're sorry, a server error has occurred.",
            duration: 0
          });
        }
      }

      return Promise.reject(response);
    } catch (error) {
      if (!skipToast) {
        errorToast({
          title: "An error occurred",
          description: "Something went wrong when loading this page."
        });
      }

      return Promise.reject(
        new Error(
          JSON.stringify({
            status: error?.response?.status,
            data: error?.response?.data
          })
        )
      );
    }
  }

  get(options) {
    return this.request({ ...options, method: "GET" });
  }

  post(options) {
    return this.request({ ...options, method: "POST" });
  }

  put(options) {
    return this.request({ ...options, method: "PUT" });
  }

  patch(options) {
    return this.request({ ...options, method: "PATCH" });
  }

  delete(options) {
    return this.request({ ...options, method: "DELETE" });
  }

  options(options) {
    return this.request({ ...options, method: "OPTIONS" });
  }
}

const API = new ApiHandler();

export default API;
